module.exports = __webpack_public_path__ + "assets/paper.151b9e4a.svg";